import PropTypes from "prop-types";

import ActionPopOutOption from "@/view/ActionPopOutOption/ActionPopOutOption.js";
import SecondaryActionButton from "@/view/SecondaryActionsToolbar/SecondaryActionButton/index.js";
import usePresentModeContext from "@/view/utils/usePresentModeContext";

const propTypes = {
  actionName: PropTypes.string,
  activeSubMenu: PropTypes.string,
  eventProperties: PropTypes.object,
  handleToggleBannerMode: PropTypes.func,
  hoverLabel: PropTypes.string,
  icon: PropTypes.node,
  isMobile: PropTypes.bool,
  disabled: PropTypes.bool,
};

const ArticlePresentAction = ({
  actionName,
  activeSubMenu,
  eventProperties,
  handleToggleBannerMode,
  hoverLabel,
  icon,
  isMobile,
  disabled,
}) => {
  const { setIsPresentModeActive } = usePresentModeContext();
  const qaSelector = actionName.toLowerCase();

  const onClick = () => {
    setIsPresentModeActive(true);
    handleToggleBannerMode();
  };

  if (isMobile && !!activeSubMenu) return null;

  if (isMobile) {
    return (
      <ActionPopOutOption
        dataProps={{ "data-qa-selector": qaSelector }}
        eventProperties={eventProperties}
        icon={icon}
        onClick={onClick}
        title="Present"
        disabled={disabled}
      />
    );
  }

  return (
    <SecondaryActionButton
      dataProps={{ "data-qa-selector": qaSelector }}
      eventProperties={eventProperties}
      hoverLabel={hoverLabel}
      icon={icon}
      onClick={onClick}
      title={actionName}
      disabled={disabled}
    />
  );
};

ArticlePresentAction.propTypes = propTypes;

export default ArticlePresentAction;
